export default __webpack_public_path__ + "static/media/sverige.bd3e102a.svg";